import { HYDRA_SEO_COPY_LOCATION } from 'constants/hydraTests';
import { SEO_COPY_HIDDEN } from 'constants/seoOptimizedDataConstants';
import { isSeoDataAvailable } from 'helpers/SeoOptimizedDataHelper';
import { getAssignmentGroup, triggerAssignment } from 'actions/ab';

const prepareEmptySeoOptimizedData = () => ({
  group: undefined,
  optimizedH1Tag: undefined,
  optimizedTitleTag: undefined,
  optimizedMetaDescription: undefined,
  optimizedSeoCopy: undefined
});

const prepareSeoOptimizedData = (assignedGroup, { optimizedH1Tag = '', optimizedTitleTag = '', optimizedMetaDescription = '', optimizedSeoCopy = '' }) => ({
  group: assignedGroup,
  optimizedH1Tag,
  optimizedTitleTag,
  optimizedMetaDescription,
  optimizedSeoCopy
});

export function generateSeoOptimizedData(dispatch, getState, response) {
  if (isSeoDataAvailable(response)) {
    dispatch(triggerAssignment(HYDRA_SEO_COPY_LOCATION));

    const assignedGroup = getAssignmentGroup(HYDRA_SEO_COPY_LOCATION, getState());
    if (assignedGroup !== SEO_COPY_HIDDEN) {
      return prepareSeoOptimizedData(assignedGroup, response.seoData);
    }
  }
  return prepareEmptySeoOptimizedData();
}
